<template>
  <div class="otcDetailOrder-header">
    <!-- 步骤条 -->
    <section class="otcDetailOrder-bar">
      <template v-for="(item, index) in domArr">
        <div class="bar-page" :key="'page' + index">
          <span class="bar-page-ball" :class="item.class" style="color: #edf4f8 !important">
            {{ index + 1 }}
          </span>
          <span class="bar-page-text" :class="item.textClass">{{ item.text }}</span>
        </div>
        <div :key="'line' + index" v-if="index !== domArr.length - 1" class="bar-line"></div>
      </template>
    </section>
    <!-- 描述文字 -->
    <div class="otcDetailOrder-text" v-if="isReady">
      <!-- 买 1 -->
      <div v-if="status === '1' && commonData.side === 'BUY'">
        <!-- 待买家付款 -->
        <span class="main-cl Conspicuous">{{ $t("otcDetailOrder.PendingPayment") }}</span
        >&nbsp;
        <!-- 付款倒计时 -->
        <span class="main-cl info">{{ $t("otcDetailOrder.CountdownPayments") }}：</span>
        <span class="red-cl Conspicuous">{{ timer }}</span>
      </div>
      <!-- 卖 1 -->
      <div v-if="status === '1' && commonData.side === 'SELL'">
        <!-- 待买家付款 倒计时 -->
        <span class="b-1-cl info">{{ $t("otcDetailOrder.WaitingCountdownPayment") }}：</span>
        <span class="b-7-cl Conspicuous">{{ timer }}</span>
      </div>
      <!-- 买 2 -->
      <div v-if="status === '2' && commonData.side === 'BUY'">
        <!-- 待卖家放币 -->
        <span class="b-7-cl Conspicuous">{{ $t("otcDetailOrder.MoneyCollected") }}</span
        >&nbsp;
        <!-- 待卖家确认收款并放币后，您将收到对应的金额 -->
        <span class="b-1-cl info">{{ $t("otcDetailOrder.MoneyCollectedWarning") }}</span>
      </div>
      <!-- 卖 2 -->
      <div v-if="status === '2' && commonData.side === 'SELL'">
        <span class="b-1-cl info">
          <!-- 买家已付款 -->
          {{ $t("otcDetailOrder.otherPartyPaid1") }}
          <!-- 标记为 -->
          {{ $t("otcDetailOrder.otherPartyPaid2") }}
          {{ payText }}
          {{ $t("otcDetailOrder.otherPartyPaid3") }}
          {{ commonData.totalPrice }} {{ commonData.paycoin }}</span
        >
      </div>
      <!-- 买 3 -->
      <div v-if="status === '3' && commonData.side === 'BUY'">
        <!-- 订单已完成 -->
        <span class="b-7-cl Conspicuous"> {{ $t("otcDetailOrder.Completedbuy1") }} </span
        >&nbsp;&nbsp;
        <!-- 您可通过 -->
        <span class="small">
          {{ $t("otcDetailOrder.Completedbuy2") }}
        </span>
        <!-- 查看资产 -->
        <span class="active b-4-cl" @click="goAss"> {{ $t("otcDetailOrder.Completedbuy3") }} </span>
        <!-- 划转至现货账户进行交易 -->
        <span class="small">
          {{ $t("otcDetailOrder.Completedbuy4") }}
        </span>
      </div>
      <!-- 卖 3 -->
      <div v-if="status === '3' && commonData.side === 'SELL'">
        <!-- 订单已完成 -->
        <span class="b-7-cl Conspicuous">
          {{ $t("otcDetailOrder.Completedsell") }}
        </span>
      </div>
      <!-- 买4 / 卖4 -->
      <!-- 订单已关闭 -->
      <div v-if="status === '4' || status === '9' || status === '10' || status === '11'">
        <span class="b-7-cl Conspicuous" v-if="status === '10'">
          {{ $t("otcDetailOrder.TitleOrderClose_buyer") }}
        </span>
        <span class="b-7-cl Conspicuous" v-else-if="status === '11'">
          {{ $t("otcDetailOrder.TitleOrderClose_timeout") }}
        </span>
        <span class="b-7-cl Conspicuous" v-else>
          {{ $t("otcDetailOrder.TitleOrderClose") }}
        </span>
      </div>
      <!-- 买5 / 卖5 -->
      <div v-if="status === '5'">
        <!-- 申诉中 -->
        <span class="b-7-cl Conspicuous"> {{ $t("otcDetailOrder.TitleComplaint") }} </span
        >&nbsp;&nbsp;
        <!-- 我们的客服人员正在积极为您处理，请您耐心等待处理结果。 -->
        <span class="small">{{ $t("otcDetailOrder.TitleComplaintText") }}</span>
      </div>
      <!-- 买7 / 卖7 -->
      <div v-if="status === '7'">
        <span class="b-7-cl Conspicuous">
          {{ $t("otcDetailOrder.TitleOrderException") }}
        </span>
      </div>
      <!-- 买 8 -->
      <div v-if="status === '8' && commonData.side === 'BUY'">
        <!-- 订单已完成 -->
        <span class="b-7-cl Conspicuous"> {{ $t("otcDetailOrder.AfterAppealbuy1") }} </span
        >&nbsp;&nbsp;
        <!-- 您可通过 -->
        <span class="small">
          {{ $t("otcDetailOrder.AfterAppealbuy2") }}
        </span>
        <!-- 查看资产 -->
        <span class="active b-4-cl" @click="goAss">
          {{ $t("otcDetailOrder.AfterAppealbuy3") }}
        </span>
        <!-- 划转至现货账户进行交易 -->
        <span class="small">
          {{ $t("otcDetailOrder.AfterAppealbuy4") }}
        </span>
      </div>
      <!-- 卖 8 -->
      <div v-if="status === '8' && commonData.side === 'SELL'">
        <!-- 订单已完成 -->
        <span class="b-7-cl Conspicuous">{{ $t("otcDetailOrder.AfterAppealsell") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getTime } from '@/utils';

export default {
  name: 'otcDetailOrder-title',
  data() {
    return {
      djsTime: 0,
      timer: '',
      vTimer: null,
    };
  },
  props: {
    // 1-5 为正常流程  6是服务端状态  7为异常订单 8按3处理(客服介入强制使订单完成)
    // 待支付1 已支付2 交易成功3 取消 4 申诉 5 打币中6 异常订单7 申诉处理结束8
    commonData: { default: () => ({}), type: Object },
    // 当前订单 是买数字货币BUY 还是卖数字货币SELL
    isReady: { default: false, type: Boolean },
  },
  watch: {
    status(v) {
      if (v === '1' && this.commonData.limitTime && this.isReady) {
        this.djsTime = this.commonData.limitTime;
        this.setTime();
      } else if (v !== '1' && v !== '0') {
        if (this.vTimer) {
          clearInterval(this.vTimer);
        }
      }
    },
  },
  computed: {
    payText() {
      let str = '';
      if (
        this.commonData.payKey
        && this.commonData.payment
        && this.$store.state.baseData.otcPublicInfo
        && this.$store.state.baseData.otcPublicInfo.payments
      ) {
        this.$store.state.baseData.otcPublicInfo.payments.forEach((item) => {
          if (item.key === this.commonData.payKey) {
            str = item.title;
          }
        });
        this.commonData.payment.forEach((item) => {
          if (item.payment === this.commonData.payKey) {
            str += ` (${item.account}) `;
          }
        });
      }
      return str;
    },
    status() {
      if (this.commonData.status) {
        return this.commonData.status.toString();
      }
      return '0';
    },
    domArr() {
      // 已拍下
      const arr = [
        // 已拍下
        {
          text: this.$t('otcDetailOrder.barText'),
          class: 'blue-bg main-cl',
          textClass: 'main-cl',
        },
      ];
      if (this.isReady) {
        const { status, side } = this.commonData;
        // 已拍下 -- 待买家付款 -- 待卖家放币
        if (status.toString() === '1' && side === 'BUY') {
          arr.push(
            // 待买家付款
            { text: this.$t('otcDetailOrder.bar1Buy1'), class: 'a-2-bg b-1-cl' },
            // 待卖家放币
            { text: this.$t('otcDetailOrder.bar1Buy2'), class: 'a-2-bg b-1-cl' },
          );
          // 已拍下 -- 待买家付款 -- 待卖家放币
        } else if (status.toString() === '1' && side === 'SELL') {
          arr.push(
            // 待买家付款
            { text: this.$t('otcDetailOrder.bar1Sell1'), class: 'a-2-bg b-1-cl' },
            // 待卖家放币
            { text: this.$t('otcDetailOrder.bar1Sell2'), class: 'a-2-bg b-1-cl' },
          );
          // 已拍下 -- 买家已付款 -- 待卖家放币
        } else if (status.toString() === '2' && side === 'BUY') {
          arr.push(
            // 买家已付款
            { text: this.$t('otcDetailOrder.bar2Buy1'), class: 'blue-bg main-cl', textClass: 'main-cl' },
            // 待卖家放币
            { text: this.$t('otcDetailOrder.bar2Buy2'), class: 'a-2-bg b-1-cl' },
          );
          // 已拍下 -- 买家已付款 -- 待卖家放币
        } else if (status.toString() === '2' && side === 'SELL') {
          arr.push(
            // 买家已付款
            { text: this.$t('otcDetailOrder.bar2Sell1'), class: 'blue-bg main-cl', textClass: 'main-cl' },
            // 待卖家放币
            { text: this.$t('otcDetailOrder.bar2Sell2'), class: 'a-2-bg b-1-cl' },
          );
          // 已拍下 -- 买家已付款 -- 卖家已放币
        } else if (status.toString() === '3' && side === 'BUY') {
          arr.push(
            // 买家已付款
            { text: this.$t('otcDetailOrder.bar3Buy1'), class: 'blue-bg main-cl', textClass: 'main-cl' },
            // 卖家已放币
            { text: this.$t('otcDetailOrder.bar3Buy2'), class: 'blue-bg main-cl', textClass: 'main-cl' },
          );
          // 已拍下 -- 买家已付款 -- 卖家已放币
        } else if (status.toString() === '3' && side === 'SELL') {
          arr.push(
            // 买家已付款
            { text: this.$t('otcDetailOrder.bar3Sell1'), class: 'blue-bg main-cl', textClass: 'main-cl' },
            // 卖家已放币
            { text: this.$t('otcDetailOrder.bar3Sell2'), class: 'blue-bg main-cl', textClass: 'main-cl' },
          );
          // 已拍下 -- 已关闭
        } else if (status.toString() === '4' || status.toString() === '9' || status.toString() === '10' || status.toString() === '11') {
          arr.push(
          // 已关闭
            { text: this.$t('otcDetailOrder.bar4Sell'), class: 'blue-bg main-cl', textClass: 'main-cl' },
          );
        // 已拍下 -- 申诉中
        } else if (status.toString() === '5') {
          arr.push({ text: this.$t('otcDetailOrder.bar5Sell'), class: 'blue-bg main-cl', textClass: 'main-cl' });
          // 已拍下 -- 异常订单
        } else if (status.toString() === '7') {
          arr.push({ text: this.$t('otcDetailOrder.bar7Sell'), class: 'blue-bg main-cl', textClass: 'main-cl' });
          // 已拍下 -- 买家已付款 -- 卖家已放币
        } else if (status.toString() === '8' && side === 'BUY') {
          arr.push(
          // 买家已付款
            { text: this.$t('otcDetailOrder.bar8Buy1'), class: 'blue-bg main-cl', textClass: 'main-cl' },
            // 卖家已放币
            { text: this.$t('otcDetailOrder.bar8Buy2'), class: 'blue-bg main-cl', textClass: 'main-cl' },
          );
        // 已拍下 -- 买家已付款 -- 卖家已放币
        } else if (status.toString() === '8' && side === 'SELL') {
          arr.push(
          // 买家已付款
            { text: this.$t('otcDetailOrder.bar8Sell1'), class: 'blue-bg main-cl', textClass: 'main-cl' },
            // 卖家已放币
            { text: this.$t('otcDetailOrder.bar8Sell2'), class: 'blue-bg main-cl', textClass: 'main-cl' },
          );
        }
      }
      return arr;
    },
  },
  beforeDestroy() {
    clearInterval(this.vTimer);
  },
  methods: {
    goAss() {
      this.$router.push('/assets/otcAccount');
    },
    setTime() {
      this.timer = this.initTime(this.djsTime);
      this.vTimer = setInterval(() => {
        this.djsTime -= 1000;
        if (this.djsTime <= 0) {
          clearInterval(this.vTimer);
          this.$emit('getData');
          return;
        }
        this.timer = this.initTime(this.djsTime);
      }, 1000);
    },
    initTime(spkTime) {
      const {
        day, hour, min, sec,
      } = getTime(spkTime);
      let str = '';
      if (Number(day)) {
        str += `${day}${this.$t('otcDetailOrder.day')}`;
      }
      if (Number(hour)) {
        str += `${hour}${this.$t('otcDetailOrder.hour')}`;
      }
      if (Number(min)) {
        str += `${min}${this.$t('otcDetailOrder.min')}`;
      }
      str += `${sec}${this.$t('otcDetailOrder.sec')}`;
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
.otcDetailOrder-header {
  padding: 60px 24px 12px 24px;
  box-sizing: content-box;

  .otcDetailOrder-bar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 54px;

    .bar-page {
      display: flex;
      align-items: center;

      .bar-page-ball {
        display: inline-block;
        width: 28px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
      }

      .bar-page-text {
        font-size: 18px;
        margin-left: 10px;
        width: max-content;
      }
    }

    .bar-line {
      flex: 1;
      height: 0;
      border-bottom-width: 1px;
      border-bottom-style: dashed;
    }
  }
  .otcDetailOrder-text {
    margin-top: 44px;

    .Conspicuous {
      font-size: 20px;
    }
    .info {
      font-size: 20px;
      margin-left: 12px;
    }
    .small {
      font-size: 12px;
    }
    .active {
      cursor: pointer;
      font-size: 12px;
    }
  }
}
</style>
